import useRouter from '~/client/hooks/router/useRouter';
import Breadcrumbs from '~/client/shared/Breadcrumbs';

type Props = {
  pageSection?: PageSection;
  providerName?: string;
  pageTitle?: string;
};

const GamesBreadcrumbs: FC<Props> = ({
  pageSection,
  pageTitle,
  providerName,
}) => {
  const { asPath } = useRouter();

  if (asPath === '/games') {
    return (
      <Breadcrumbs showLogo breadcrumbs={[{ translateId: 'general.games' }]} />
    );
  }

  if (pageSection === 'providers') {
    return (
      <Breadcrumbs
        showLogo
        breadcrumbs={[
          { to: '/providers', translateId: 'casino.providers' },
          { translateId: providerName },
        ]}
      />
    );
  }

  return (
    <Breadcrumbs
      showLogo
      breadcrumbs={[
        { to: '/games', translateId: 'general.games' },
        { translateId: pageTitle },
      ]}
    />
  );
};

export default GamesBreadcrumbs;
